import React from 'react';

export default{

    blogs: [
        {
            tag: "DevOps",
            image: "https://imgix.datadoghq.com/img/blog/single-step-instrumentation/single-step-hero.png?auto=compress%2Cformat&cs=origin&lossless=true&fit=max&q=75&w=1400&dpr=2",
            title: "Achieve total app visibility in minutes with Single Step Instrumentation",
            link: "https://www.datadoghq.com/blog/single-step-instrumentation/"
        },
        {
            tag: "DevOps",
            image: "https://imgix.datadoghq.com/img/blog/azure-workflow-automation/azure-actions-hero.png?auto=compress%2Cformat&cs=origin&lossless=true&fit=max&q=75&w=1400&dpr=2",
            title: "Azure Workflow Automation: Streamline and Secure Your Cloud Operations",
            link: "https://www.datadoghq.com/blog/azure-workflow-automation/"
        },
        {
            tag: "Product Management",
            image: "https://hackernoon.com/images/fNRMw5jFDeSGIovubGOuX9XvR0Z2-bj3v310a.jpeg",
            title: "Are We Measuring Product Success Correctly? - Advice for PMs",
            link: "https://hackernoon.com/are-we-measuring-product-success-correctly-advice-for-pms-z54f34dt"
        },

        {
            tag: "Cloud Computing",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "Active/Active Multi-Region Systems on Steroids With Serverless",
            link: "https://medium.com/@yusuf_82810/active-active-multi-region-systems-on-steroids-with-serverless-c3408788102f"
        },

        {
            tag: "DevOps",
            image: "https://dz2cdn3.dzone.com/thumbnail?fid=14591738&w=125&h=200",
            title: "The Myth of NoOps",
            link: "https://dzone.com/articles/the-myth-of-noops"
        },

        {
            tag: "DevOps",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "Ebbs and Flows Of DevOps Debugging PART 2",
            link: "https://medium.com/@yusuf_82810/ebbs-and-flows-of-devops-debugging-part-2-4fb7bb094364"
        },

        {
            tag: "DevOps",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "Ebbs and Flows Of DevOps Debugging PART 1",
            link: "https://medium.com/@yusuf_82810/ebbs-and-flows-of-devops-debugging-part-i-b6acecc2ee4d"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn3.dzone.com/thumbnail?fid=14439246&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "The Theory and Motive Behind Active/Active Multi-Region Architectures",
            link: "https://dzone.com/articles/the-theory-and-motive-behind-activeactive-multi-re"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn3.dzone.com/thumbnail?fid=14355170&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "CaaS Services Through AWS, Azure, and Google Cloud",
            link: "https://dzone.com/articles/caas-services-through-aws-azure-and-google-cloud"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn3.dzone.com/thumbnail?fid=13817578&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Breaking Down Serverless Anti-Patterns",
            link: "https://dzone.com/articles/breaking-down-serverless-anti-patterns"
        },

        {
            tag: "Cloud Computing",
            image: "https://cdn.thenewstack.io/media/2020/10/8bfc6b06-lion-4683920_1280-1024x682.jpg",
            title: "A 2020 Guide to Computing on Amazon Web Services",
            link: "https://thenewstack.io/a-2020-guide-to-computing-on-amazon-web-services/"
        },

        {
            tag: "DevOps",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "Strengthening Observability With Dashboard as Code",
            link: "https://medium.com/@yusuf_82810/strengthening-observability-with-dashboard-as-code-a40d14ee31e5"
        },

        {
            tag: "Cloud Computing",
            image: "https://cdn.thenewstack.io/media/2020/10/b00d98be-peacock-feathers-3013486_1280-1024x683.jpg",
            title: "Avoiding Serverless Anti-Patterns with Observability",
            link: "https://thenewstack.io/avoiding-serverless-anti-patterns-with-observability/"
        },

        {
            tag: "DevOps",
            image: "https://3ovyg21t17l11k49tk1oma21-wpengine.netdna-ssl.com/wp-content/uploads/2020/08/serverless.jpg",
            title: "How Serverless Technologies Can Achieve Optimal DevOps Practices",
            link: "https://devops.com/how-serverless-technologies-can-achieve-optimal-devops-practices/"
        },

        {
            tag: "DevOps",
            image: "https://miro.medium.com/max/1000/1*NLHywA0dSJyTR_mIP5pKYA.png",
            title: "An Observability Balancing Act With Gitops",
            link: "https://medium.com/thundra/an-observability-balancing-act-with-gitops-a3366daef7a1"
        },

        {
            tag: "DevOps",
            image: "https://dz2cdn1.dzone.com/thumbnail?fid=13521088&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Under the Hood of GitOps",
            link: "https://dzone.com/articles/under-the-hood-of-gitops"
        },

        {
            tag: "Cloud Computing",
            image: "https://miro.medium.com/max/1000/1*eDfkZLSUz27AaEwF1LSL4g.png",
            title: "Expanding the Serverless War Chest With AWS EFS",
            link: "https://medium.com/thundra/expanding-the-serverless-war-chest-with-aws-efs-dea3b003ee8d"
        },

        {
            tag: "DevOps",
            image: "https://community.atlassian.com/html/assets/atlassian-community-opengraph.png",
            title: "DevOps Just Got a Whole Lot Easier with Opsgenie and AWS CloudFormation Registry and CLI",
            link: "https://community.atlassian.com/t5/DevOps-Articles/DevOps-Just-Got-a-Whole-Lot-Easier-with-Opsgenie-and-AWS/ba-p/1230979"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn2.dzone.com/thumbnail?fid=13271929&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "The Serverless Path to DevOps",
            link: "https://dzone.com/articles/the-serverless-path-to-devops"
        },

        {
            tag: "Cloud Computing",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "The Comforts of GraphQL with AWS AppSync",
            link: "https://medium.com/@yusuf_82810/the-comforts-of-graphql-with-aws-appsync-d8b36b9c67"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn2.dzone.com/thumbnail?fid=13088613&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Provisioned Concurrency: The Silver Bullet to AWS Lambda Cold Starts",
            link: "https://dzone.com/articles/provisioned-concurrency-the-silver-bullet-to-aws-l"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn3.dzone.com/thumbnail?fid=12937666&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Introducing Quantum-as-a-Service with AWS Braket",
            link: "https://dzone.com/articles/introducing-quantum-as-a-service-with-aws-braket"
        },

        {
            tag: "Cloud Computing",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "A Step Towards Observability with Lambda Destinations",
            link: "https://medium.com/@yusuf_82810/a-step-towards-observability-with-lambda-destinations-110e2caf0605"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn1.dzone.com/thumbnail?fid=12744020&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Rethinking Serverless Architectures With Eventbridge",
            link: "https://dzone.com/articles/rethinking-serverless-architectures-with-eventbrid"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn4.dzone.com/thumbnail?fid=12525335&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Rethinking Serverless Architectures With Eventbridge",
            link: "https://dzone.com/articles/explaining-eventbridge-amidst-the-hype"
        },

        {
            tag: "Cloud Computing",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "Building Serverless IoT Systems from Node-RED to AWS Lambda",
            link: "https://medium.com/@yusuf_82810/building-serverless-iot-systems-from-node-red-to-aws-lambda-ebe991c64d22"
        },

        {
            tag: "Cloud Computing",
            image: "https://community.atlassian.com/html/assets/atlassian-community-opengraph.png",
            title: "Building for the Cloud with Atlassian's Opsgenie and AWS Eventbridge",
            link: "https://community.atlassian.com/t5/Opsgenie-articles/Building-for-the-Cloud-with-Atlassian-s-Opsgenie-and-AWS/ba-p/1244404"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn1.dzone.com/thumbnail?fid=12218584&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Accelerating Agile With Serverless",
            link: "https://dzone.com/articles/accelerating-agile-with-serverless"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn2.dzone.com/thumbnail?fid=11995113&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Getting It Right Between EC2, Fargate and Lambda",
            link: "https://dzone.com/articles/getting-it-right-between-ec2-fargate-and-lambda"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn2.dzone.com/thumbnail?fid=11885473&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "The Best of Both Worlds With AWS Fargate",
            link: "https://dzone.com/articles/the-best-of-both-worlds-with-aws-fargate"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn2.dzone.com/thumbnail?fid=11815237&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Using IoT and Serverless: Tackling Global Issues",
            link: "https://dzone.com/articles/using-iot-with-serverless-to-tackle-global-issues"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn2.dzone.com/thumbnail?fid=11815237&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Using IoT and Serverless: Tackling Global Issues",
            link: "https://dzone.com/articles/using-iot-with-serverless-to-tackle-global-issues"
        },

        {
            tag: "Cloud Computing",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "Making AppSync Easier with Thundra",
            link: "https://medium.com/@yusuf_82810/making-appsync-easier-with-thundra-6570994cda5b"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn2.dzone.com/thumbnail?fid=11714597&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "Holy Grail of Solutions: Solving .NET Lambda Cold Start Part 2",
            link: "https://dzone.com/articles/holy-grail-of-solutions-solving-net-lambda-cold-st"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn4.dzone.com/thumbnail?fid=11691719&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "The Fundamental Problem: Solving .NET Lambda Cold Starts, Part 1",
            link: "https://dzone.com/articles/the-fundamental-problem-solving-net-lambda-cold-st"
        },

        {
            tag: "Cloud Computing",
            image: "https://dz2cdn4.dzone.com/thumbnail?fid=11092787&w=125&caller=dzImageFid-article.listV2&uri=/users/3508676/syedsarj.html&h=200",
            title: "The Comforts of GraphQL With AWS AppSync",
            link: "https://dzone.com/articles/the-comforts-of-graphql-with-aws-appsync"
        },

        {
            tag: "Cloud Computing",
            image: "https://miro.medium.com/max/1400/1*-5_NqMqzqzqzqzqzqzqzqQ.png",
            title: "Detailed Serverless Monitoring Using a Completely Automated Approach",
            link: "https://medium.com/@yusuf_82810/detailed-serverless-monitoring-using-a-completely-automated-approach-c148fa8cfa47"
        },

    ],
};